// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navigation[data-v-6d886ef8]{margin:2em 0;padding:0 15px}.navigation-content[data-v-6d886ef8]{text-align:center}.navigation-button[data-v-6d886ef8]{margin-top:1em;margin-bottom:1em}", ""]);
// Exports
module.exports = exports;
